import { GAME_ID, ACTION_TYPES, OBJECTS_PER_SCENE } from 'a/stickerBook/data/constants';

/**
 * This reducer manages state related to Searchlight reporting events.
 */

const initialState = {
  currentMasteryScore: 0,
  masteryTarget: 7,
  onboarding: false,
  isLevelComplete: false,
  helpsUsed: 0,
};

const gameLevelReducer = (state = initialState, { type, payload, gameId }) => {
  if (gameId !== GAME_ID) {
    return state;
  }

  switch (type) {
    case ACTION_TYPES.LOAD_LEVEL:
      return initialState;
    case ACTION_TYPES.INCREMENT_MASTERY_SCORE: {
      return {
        ...state,
        currentMasteryScore: state.currentMasteryScore + 1,
      };
    }
    case ACTION_TYPES.INCREMENT_HELP_INDEX: {
      return {
        ...state,
        helpsUsed: state.helpsUsed + 1,
      };
    }
    case ACTION_TYPES.QUICK_ROUND: {
      const numCorrect = payload.pass ? OBJECTS_PER_SCENE : 0;
      return {
        ...state,
        currentMasteryScore: numCorrect,
      };
    }
    default:
      return state;
  }
};

export default gameLevelReducer;
